<button class="guide-trigger" mat-icon-button (click)="openModal()" (keydown.enter)="openModal()" (keydown.space)="openModal()">
  <mat-icon [svgIcon]="'question_circle'"></mat-icon>
</button>

<div class="overlay"></div>
